import * as React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {Alert, TextFieldProps} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {DatePicker} from '@mui/x-date-pickers';
import dayjs from "dayjs";

export type FormInputDateProps = Omit<TextFieldProps, 'name'> & {
   name: string;
   label: string;
   errorMessage?: string
}

export const FormInputDate = ({name, label, errorMessage, ...rest}: FormInputDateProps) => {
   const classes = useStyles();

   const methods = useFormContext();
   const {formState: {errors}, control} = methods;
   const showError = !!errors[name];

   return (
      <div className={classes.noBorderRadius}>
         <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({
                        field: {onChange, value},
                        fieldState: {invalid}
                     }) => (
               <DatePicker
                  label={label}
                  value={value ? new Date(value) : null}
                  format={"dd/MM/yyyy"}
                  onChange={(value) => {
                     if(!value) {
                        onChange(null);
                     } else {
                        onChange(dayjs(value).format("YYYY-MM-DD"))
                     }
                  }}
                  slotProps={{
                     textField: {
                        id: name,
                        size: "small",
                        variant: "filled",
                        margin: "none",
                        fullWidth: true,
                        error: invalid,
                        helperText: invalid ? errorMessage : null,
                        InputLabelProps: {shrink: true},
                        InputProps: {
                           disableUnderline: true,
                           style: {backgroundColor: 'transparent'}
                        },
                        style: {
                           border: showError ? '1px solid #f00000' : '1px solid #d0d0d0',
                           marginBottom: '8px'
                        }
                     }
                  }}
               />
            )}
         />
         {showError && <Alert variant="filled" severity="error">{errors[name]?.message}</Alert>}
      </div>
   );
};

const useStyles = makeStyles({
   noBorderRadius: {
      "& fieldset": {
         borderRadius: 0,
      },
      width: '100%'
   }
});
